<div class="modal" id="addModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-3">
	<div class="modal-dialog">
		<div class="modal-content">
			<div class="modal-header">
				<button type="button" class="btn-close" (click)="dialogClose()"></button>
			</div>
			<div class="modal-body">
				<div class="form-floating mb-3">
					<select class="form-select" id="restaurantList" name="restaurantList" [(ngModel)]="restaurant">
						<option [value]="item.id" *ngFor="let item of restaurantList">
							{{ item.name }}
						</option>
					</select>
					<label for="restaurantList">Rodzaj właściciela</label>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-primary" (click)="submit()">Przypisz</button>
				<button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="dialogClose()">
					Anuluj
				</button>
			</div>
		</div>
	</div>
</div>
